import Vue from 'vue'
import { ToastPlugin, ModalPlugin, IconsPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'
import VueMeta from 'vue-meta';

Vue.use(VueMeta);

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'

// Install the Plugin.
//Vue.use(VeeValidate)

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

//Portal vue
import PortalVue from 'portal-vue'
Vue.use(PortalVue)

//VueScroll
import vuescroll from 'vuescroll';
Vue.use(vuescroll)

//VueClipboaard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


// Localize takes the locale object as the second argument (optional) and merges it.
//Validator.localize('es', es)

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(IconsPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

// import darkmode styles
require('@/assets/css/stylesDarkMode.scss');


// Theme engine (persistent theming)
import { ThemePlugin, themeEngine, generateFullThemeFromUserInput } from '@/libs/theme-engine'
import { getUserData } from '@/libs/utils/user'

Vue.use(ThemePlugin);

// Apply whitelabel theme if exists and no theme is set yet
try {
  const isWhitelabelThemeActive = process.env.VUE_APP_IS_WHITELABEL_THEME_ACTIVE === 'true';
  if (!localStorage.getItem('brandme_theme')) {
    const userData = getUserData();
    if (userData?.main_group?.name === 'whitelabel' && isWhitelabelThemeActive) {
      const rawSettings = userData?.whitelabel_settings?.settings
      let parsed = {}
      if (rawSettings) {
        if (typeof rawSettings === 'string') {
          try { parsed = JSON.parse(rawSettings) } catch (e) { parsed = {} }
        } else if (typeof rawSettings === 'object') {
          parsed = rawSettings
        }
      }
      if (parsed.primary) {
        const theme = generateFullThemeFromUserInput({
          primary: parsed.primary || '#7367f0',
          textOnPrimary: parsed.textOnPrimary || null,
          headerBg: parsed.headerBg || 'linear-gradient(120deg ,#6947bc, #993e90)',
          isWhitelabel: !!rawSettings
        })
        themeEngine.applyTheme(theme)
      }
    }
  }
} catch (e) {
  console.warn('No se pudo aplicar tema whitelabel inicial:', e)
}
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
